angular.module('eva2-angular')
  .controller('RecentItemsController', function() {
    'use strict';
  });
